var map = {
	"./bat": 730,
	"./coffee": 731,
	"./cpp": 732,
	"./csharp": 733,
	"./css": 734,
	"./dockerfile": 735,
	"./fsharp": 736,
	"./go": 737,
	"./handlebars": 738,
	"./html": 739,
	"./ini": 740,
	"./java": 741,
	"./less": 742,
	"./lua": 743,
	"./markdown": 744,
	"./monaco.contribution": 294,
	"./msdax": 745,
	"./objective-c": 746,
	"./php": 747,
	"./postiats": 748,
	"./powershell": 749,
	"./pug": 750,
	"./python": 751,
	"./r": 752,
	"./razor": 753,
	"./ruby": 754,
	"./sb": 755,
	"./scss": 756,
	"./solidity": 757,
	"./sql": 758,
	"./swift": 759,
	"./vb": 760,
	"./xml": 761,
	"./yaml": 762
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 729;


//////////////////
// WEBPACK FOOTER
// ./submodules/monaco-languages/src
// module id = 729
// module chunks = 0